import CountUp from "react-countup";
import { Container, Wrapper } from "./style";
import { useMemo } from "react";

const RankingTable = ({ content, index }) => {

  const sortRanking = useMemo(() => {
    if (content.length === 1) return content
    return content.sort((a, b) => {
      if (a.margemBruta > b.margemBruta) {
        return -1
      }
      if (a.margemBruta < b.margemBruta) {
        return 1
      }
      return 0
    })
  }, [content])

  return (
    <Container>
      <Wrapper>
        <p>
          Rodada <span>{index}</span>
        </p>
      </Wrapper>

      {sortRanking?.map((item, index) => (
        <tr key={index}>
          <td className='nameRow'>{item.nome}</td>
          <td>
            <CountUp
              style={{ color: item.margemBruta < 0 ? 'red' : '#2AFAA5' }}
              end={item.margemBruta}
              prefix=" R$ "
              separator="."
              decimal=","
              decimals={2}
              duration={0.5}
            />
          </td>
        </tr>
      ))}
    </Container>
  );
};
export default RankingTable;

{
  /* <CountUp
          end={150000}
          prefix="D$ "
          separator="."
          decimal=","
          decimals={2}
          duration={0.5}
        /> */
}
